import {useParams} from 'react-router-dom';
import {useSnackbar} from "../../../context/SnackbarContext/SnackbarContext";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_URL, COLOR_SECONDARY} from "../../../config";
import breakpoints from "../../../assets/theme/base/breakpoints";
import {Profile} from "./components/Profile/Profile";
import Sales from "./components/Sales/Sales";
import Patients from "./components/Patients/Patients";
import Payouts from "./components/Payouts/Payouts";
import {useSelector} from "react-redux";
import MDBox from "../../../components/MDBox";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import bgImage from "../../../assets/images/bg_doctor.jpg";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "../../../components/MDTypography";
import AppBar from "@mui/material/AppBar";
import {Tab, Tabs} from "@mui/material";
import Icon from "@mui/material/Icon";

const useDoctorDetails = () => {

    const {id} = useParams();

    const { isLoggedIn } = useSelector((state) => state.authReducer);

    const { showSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    const [doctor, setDoctor] = useState(null);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadDoctor();
            setIsLoading(false);
        };

        init();
    }, []);

    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /**
         The event listener that's calling the handleTabsOrientation function when resizing the window.
         */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    const handleSetTabValue = (event, newValue) => setTabValue(newValue);

    const loadDoctor = async () => {

        try {

            const response = await axios.get(`${API_URL}/doctors/${id}`);

            setDoctor(response.data.data);

        } catch (error) {

            showSnackbar('Statistics', 'Ocurrió un error cargando el doctor', 'cancel', 'warning');
        }

    };

    const renderTabContent = () => {
        switch (tabValue){
            case 0:
                return <Profile doctor={doctor} isLoggedIn={isLoggedIn}/>;
            case 1:
                return <Sales id={doctor.id} />;
            case 2:
                return <Payouts id={doctor.id} />;
            case 3:
                return <Patients id={doctor.id} />;
        }
    };

    const renderMainContent = () => {
        return <MDBox my={2}>
            {
                isLoading ?
                    <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                           alignItems="center">
                        <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
                    </MDBox> :
                    <>
                        <MDBox py={12} sx={{position: 'relative', backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center center', borderRadius: 4}}>
                            <MDBox sx={{backgroundColor: COLOR_SECONDARY, opacity: 0.5, position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, borderRadius: 4}}></MDBox>
                        </MDBox>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} lg={12}>
                                <Card sx={{marginTop: -8}}>
                                    <MDBox p={4}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} lg={6}>
                                                <MDTypography variant="h5">{doctor.name}</MDTypography>
                                                <MDTypography variant="subtitle2">{doctor.badge}</MDTypography>
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                {
                                                    isLoggedIn &&
                                                    <AppBar position="static">
                                                        <Tabs
                                                            orientation={tabsOrientation}
                                                            value={tabValue}
                                                            onChange={handleSetTabValue}
                                                        >
                                                            <Tab
                                                                label="Perfil"
                                                                icon={
                                                                    <Icon fontSize="small" sx={{ mt: 0.626, mr: 1 }}>
                                                                        person
                                                                    </Icon>
                                                                }
                                                            />
                                                            <Tab
                                                                label="Ventas"
                                                                icon={
                                                                    <Icon fontSize="small" sx={{ mt: 0.626, mr: 1 }}>
                                                                        receipt
                                                                    </Icon>
                                                                }
                                                            />
                                                            <Tab
                                                                label="Pagos"
                                                                icon={
                                                                    <Icon fontSize="small" sx={{ mt: 0.626, mr: 1 }}>
                                                                        attach_money
                                                                    </Icon>
                                                                }
                                                            />
                                                            <Tab
                                                                label="Pacientes"
                                                                icon={
                                                                    <Icon fontSize="small" sx={{ mt: 0.626, mr: 1 }}>
                                                                        face
                                                                    </Icon>
                                                                }
                                                            />
                                                        </Tabs>
                                                    </AppBar>
                                                }
                                            </Grid>

                                        </Grid>
                                        {
                                            renderTabContent()
                                        }
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </>
            }
        </MDBox>
    }

    return {
        id,
        isLoggedIn,
        isLoading,
        doctor,
        tabsOrientation,
        tabValue,
        handleSetTabValue,
        renderTabContent,
        renderMainContent
    };
};

export default useDoctorDetails;
